import { FunctionComponent, lazy, Fragment } from 'react'
import { Switch, Route } from 'react-router-dom'

const PsychologistSearch = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/ScheduledPsyAlive/pages/PsyAliveSearch'
    ),
)

const PsychologistNewSearch = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/ScheduledPsyAlive/pages/PsyAliveNewSearch'
    ),
)
const PsychologistFullProfile = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/ScheduledPsyAlive/pages/PsychologistFullProfile/PsychologistFullProfile.component'
    ),
)

const routes = [
  <Route
    path="/atendimento-agendado-psicologo/busca-profissional"
    key="/atendimento-agendado-psicologo/busca-profissional"
    exact
    component={PsychologistSearch}
  />,
  <Route
    path="/atendimento-agendado-psicologo/busca-profissional/v2"
    key="/atendimento-agendado-psicologo/busca-profissional/v2"
    exact
    component={PsychologistNewSearch}
  />,
  <Route
    path="/atendimento-agendado-psicologo/perfil/:professionalId"
    key="/atendimento-agendado-psicologo/perfil/:professionalId"
    exact
    component={PsychologistFullProfile}
  />,
  <Route
    path="/atendimento-agendado-psicologo/perfil/:professionalId/:token"
    key="/atendimento-agendado-psicologo/perfil/:professionalId/:token"
    exact
    component={PsychologistFullProfile}
  />,
]

const ScheduledPsyAliveRoutes: FunctionComponent = () => (
  <Fragment>
    <Switch>{routes}</Switch>
  </Fragment>
)

export default ScheduledPsyAliveRoutes
